// Keep body portals aligned with the landscape game viewport.
export function syncLandscapeViewport(width, height) {
  const rotated = width <= height
  const viewWidth = rotated ? height : width
  const viewHeight = rotated ? width : height
  document.documentElement.dataset.pwShortLandscape = String(viewHeight <= 430)
  const style = document.documentElement.style
  style.setProperty('--pw-view-width', viewWidth + 'px')
  style.setProperty('--pw-view-height', viewHeight + 'px')
  style.setProperty('--pw-view-left', (width - viewWidth) / 2 + 'px')
  style.setProperty('--pw-view-top', (height - viewHeight) / 2 + 'px')
  style.setProperty('--pw-view-rotation', rotated ? '90deg' : '0deg')
}
